
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"6.364","height":"10.607","x":"14.689","y":".825","fill":"none","rx":".828","ry":"0","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","transform":"scale(.91667) rotate(-45 17.871 6.128)"}}),_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.375005","d":"M14.318 7.682l-4.005 4.006M11.118 16.382h0a2.75 2.75 0 000-3.889l-1.895-1.895h0a1.375 1.375 0 00-1.946 0L3.035 14.84h0a1.375 1.375 0 000 1.945l1.896 1.896h0a2.75 2.75 0 003.888 0z"}}),_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.375005","d":"M9.625 11h0a2.285 2.285 0 010-2.75h0a1.385 1.385 0 012.063 0l3.722 3.723h0a2.513 2.513 0 010 3.554h0a1.375 1.375 0 000 1.946l3.84 3.84M4.125 17.875L.688 21.313M7.104 19.48l1.834 1.833"}})])
          )
        }
      }
    